// extracted by mini-css-extract-plugin
export var desc = "FeaturedLink-module--desc--836d8";
export var featuredLink = "FeaturedLink-module--featuredLink--a6cc0";
export var icon = "FeaturedLink-module--icon--a2a7c";
export var isSecondary = "FeaturedLink-module--isSecondary--98bac";
export var title = "FeaturedLink-module--title--4b6e8";